import { Button } from "@material-ui/core";
import React, { useEffect } from "react";
import {
  Box,
  ButtonBase,
  FormControl,
  InputLabel,
  Link,
  MenuItem,
  Modal,
  TextField,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import { validatePincode } from "../../../Supporting files/HelpingFunction";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import SelectDropdown from "../../../Supporting files/SelectDropdown/SelectDropdown";
import RKTextField from "../../../Supporting files/RKTextField/RKTextField";
import SlidingPanel from "react-sliding-side-panel";

interface Props {
  attrName: string;
  open_status: boolean;
  value_update: Function;
}

const TermForm: React.FC<Props> = ({ open_status, value_update, attrName }) => {
  useEffect(() => {
    var age_data = [];
    for (var i = 18; i <= 100; i++) {
      age_data.push({ value: i.toString(), label: i.toString() + " Years" });
    }
    setAgeData(age_data);
  }, []);

  const [doYouSmoke, setDoYouSmoke] = React.useState("N");
  const [termGender, setTermGender] = React.useState("M");
  const [annualIncome, setAnnualIncome] = React.useState("");
  const [termAge, setTermAge] = React.useState("");
  const [pincode, setPincode] = React.useState("");
  const [warnAnnualIncome, setWarnAnnualIncome] = React.useState(false);
  const [warnTermAge, setWarnTermAge] = React.useState(false);
  const [warnPincode, setWarnPincode] = React.useState(false);
  const [ageData, setAgeData] = React.useState([
    { value: "18", label: "18 Years" },
  ]);
  const [pageStatus, setPageStatus] = React.useState<number>(1);
  const handleChange = (event: SelectChangeEvent, attrName: string) => {
    if (attrName === "annualIncome") {
      setAnnualIncome(event.target.value as string);
      setWarnAnnualIncome(
        event.target.value.toString().length == 0 ? true : false
      );
    } else if (attrName === "termAge") {
      setTermAge(event.target.value as string);
      setWarnTermAge(event.target.value.toString().length == 0 ? true : false);
    }
  };

  // const handleChangeTextField = (value: string, attrName: string) => {
  //   if (attrName === "termPincode") {
  //     setTermPincode(value);
  //     setWarnTermPincode(!validatePincode(value));
  //   }
  // };

  const validateTermForm = () => {
    let warn_annual_income = annualIncome.toString().length == 0 ? true : false;
    let warn_age = termAge.toString().length == 0 ? true : false;
    let warn_pincode = pincode.toString().length == 0 ? true : false;

    setWarnAnnualIncome(warn_annual_income);
    setWarnTermAge(warn_age);
    setWarnPincode(warn_pincode);

    if (
      warn_annual_income == false &&
      warn_age == false &&
      warn_pincode == false
    ) {
    }
  };

  const updateMasterState = (
    attrName: any,
    value: string | boolean | number
  ) => {
    attrName(value);
  };
  const changePageStatus = (status: boolean) => {
    if (status === true) {
      if (pageStatus < 2) {
        setPageStatus(pageStatus + 1);
      }
    } else {
      if (pageStatus > 1) {
        setPageStatus(pageStatus - 1);
      }
    }
  };
  const annual_income_data = [
    { key: "5 Lakhs", value: "5 Lakhs" },
    { key: "6 Lakhs", value: "6 Lakhs" },
    { key: "7 Lakhs", value: "7 Lakhs" },
    { key: "8 Lakhs", value: "8 Lakhs" },
    { key: "9 Lakhs", value: "9 Lakhs" },
    { key: "10 Lakhs", value: "10 Lakhs" },
  ];
  const termAge_data = [
    { key: "26 years", value: "26 years" },
    { key: "27 years", value: "27 years" },
    { key: "28 years", value: "28 years" },
    { key: "29 years", value: "29 years" },
    { key: "30 years", value: "30 years" },
    { key: "31 years", value: "31 years" },
  ];
  return (
    // <Modal open={open_status} className="modalWrapper">
    //   <Box className="modalInner md-width">
    //     <Grid container spacing={2}>
    //       <Grid xs={12}>
    //         <Link
    //
    //           className="close-button"
    //           onClick={() => {
    //             value_update(attrName, false);
    //           }}
    //         />
    //         <h5 className="popup-heading mb-4">Term Insurance</h5>
    //       </Grid>
    //       <Grid xs={6} sx={{ textAlign: "center" }}>
    //         <p className="popup-subheading">Do you smoke?</p>
    //         <div className="main-border-ncb">
    //           <Button
    //             style={{ textTransform: "capitalize" }}
    //             className={doYouSmoke == "N" ? "ncbSelect" : "ncb"}
    //             onClick={() => {
    //               setDoYouSmoke("N");
    //             }}
    //           >
    //             No
    //           </Button>
    //           <Button
    //             style={{ textTransform: "capitalize" }}
    //             className={doYouSmoke == "Y" ? "ncbSelect" : "ncb"}
    //             onClick={() => {
    //               setDoYouSmoke("Y");
    //             }}
    //           >
    //             Yes
    //           </Button>
    //         </div>
    //       </Grid>
    //       <Grid xs={6} sx={{ textAlign: "center" }}>
    //         <p className="popup-subheading">Gender</p>
    //         <div className="main-border-ncb">
    //           <Button
    //             style={{ textTransform: "capitalize" }}
    //             className={termGender == "M" ? "ncbSelect" : "ncb"}
    //             onClick={() => {
    //               setTermGender("M");
    //             }}
    //           >
    //             Male
    //           </Button>
    //           <Button
    //             style={{ textTransform: "capitalize" }}
    //             className={termGender == "F" ? "ncbSelect" : "ncb"}
    //             onClick={() => {
    //               setTermGender("F");
    //             }}
    //           >
    //             Female
    //           </Button>
    //         </div>
    //       </Grid>
    //     </Grid>

    //     <Grid container spacing={2} justifyContent="center" className="mb-4">
    //       <Grid xs={4} className="inputField">
    //         <SelectDropdown
    //          class_name="inputField"
    //           title="Annual  Income"
    //           value={annualIncome}
    //           attrName={setAnnualIncome}
    //           value_update={updateMasterState}
    //           dropdown_data={annual_income_data}
    //           warn_status={false}
    //         />
    //         {""}
    //       </Grid>
    //       <Grid xs={4} className="inputField">
    //         <SelectDropdown
    //          class_name="inputField"
    //           title="Age"
    //           value={termAge}
    //           attrName={setTermAge}
    //           value_update={updateMasterState}
    //           dropdown_data={termAge_data}
    //           warn_status={false}
    //         />
    //       </Grid>
    //       <Grid xs={4}>
    //         <RKTextField
    //           class_name="inputField"
    //           title="Pincode"
    //           value={pincode}
    //           value_update={updateMasterState}
    //           attrName={setPincode}
    //           warn_status={warnPincode}
    //         />
    //       </Grid>
    //     </Grid>
    //     <Grid container spacing={2}>
    //       <Grid xs={12} className="ctaBtn" style={{ textAlign: "center" }}>
    //         <Button
    //           className="submitBtn"
    //           onClick={() => {
    //             validateTermForm();
    //           }}
    //         >
    //           Get Quote
    //         </Button>
    //       </Grid>
    //     </Grid>
    //   </Box>
    // </Modal>
    <>
      {/* <SlidingPanel
        type={"right"}
        isOpen={open_status}
        size={75}
        backdropClicked={() => value_update(attrName, false)}>
        <div className={open_status == true ? "modalInner show" : "modalInner"}>
          <Grid container spacing={2}>
            <Grid xs={12}>
              <h4 className="mb-0 mt-2">Term Insurance </h4>
            </Grid>
            <Grid xs={12}>
              <hr />
            </Grid>
            <Grid xs={6} sx={{ textAlign: "center" }}>
              <p className="popup-subheading">Do you smoke?</p>
              <div className="main-border-ncb">
                <Button
                  style={{ textTransform: "capitalize" }}
                  className={doYouSmoke == "N" ? "ncbSelect" : "ncb"}
                  onClick={() => {
                    setDoYouSmoke("N");
                  }}>
                  No
                </Button>
                <Button
                  style={{ textTransform: "capitalize" }}
                  className={doYouSmoke == "Y" ? "ncbSelect" : "ncb"}
                  onClick={() => {
                    setDoYouSmoke("Y");
                  }}>
                  Yes
                </Button>
              </div>
            </Grid>
            <Grid xs={6} sx={{ textAlign: "center" }}>
              <p className="popup-subheading">Gender</p>
              <div className="main-border-ncb">
                <Button
                  style={{ textTransform: "capitalize" }}
                  className={termGender == "M" ? "ncbSelect" : "ncb"}
                  onClick={() => {
                    setTermGender("M");
                  }}>
                  Male
                </Button>
                <Button
                  style={{ textTransform: "capitalize" }}
                  className={termGender == "F" ? "ncbSelect" : "ncb"}
                  onClick={() => {
                    setTermGender("F");
                  }}>
                  Female
                </Button>
              </div>
            </Grid>
          </Grid>

          <Grid container spacing={2} justifyContent="center" className="mb-4">
            <Grid xs={4} className="inputField">
              <SelectDropdown
                class_name="inputField"
                title="Annual  Income"
                value={annualIncome}
                attrName={setAnnualIncome}
                value_update={updateMasterState}
                dropdown_data={annual_income_data}
                warn_status={false}
              />
              {""}
            </Grid>
            <Grid xs={4} className="inputField">
              <SelectDropdown
                class_name="inputField"
                title="Age"
                value={termAge}
                attrName={setTermAge}
                value_update={updateMasterState}
                dropdown_data={termAge_data}
                warn_status={false}
              />
            </Grid>
            <Grid xs={4}>
              <RKTextField
                class_name="inputField"
                title="Pincode"
                value={pincode}
                value_update={updateMasterState}
                attrName={setPincode}
                warn_status={warnPincode}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid xs={12} className="ctaBtn" style={{ textAlign: "center" }}>
              <Button
                className="submitBtn"
                onClick={() => {
                  validateTermForm();
                }}>
                Get Quote
              </Button>
            </Grid>
          </Grid>
        </div>
      </SlidingPanel> */}
      <SlidingPanel
        type={"right"}
        isOpen={open_status}
        size={75}
        backdropClicked={() => value_update(attrName, false)}
      >
        <div>
          {pageStatus == 2 ? null : (
            <Grid container spacing={3} alignItems="center">
              <Grid xs={6}>
                <h4 className="mb-0 mt-2">Term Insurance</h4>
              </Grid>
            </Grid>
          )}
          {pageStatus == 2 ? null : (
            <div className="scrollable_area">
              <Grid
                container
                spacing={2}
                justifyContent="center"
                className="mb-4"
              >
                <Grid xs={6} sx={{ textAlign: "center" }}>
                  <p className="popup-subheading">Do you smoke?</p>
                  <div className="main-border-ncb">
                    <Button
                      style={{ textTransform: "capitalize" }}
                      className={doYouSmoke == "N" ? "ncbSelect" : "ncb"}
                      onClick={() => {
                        setDoYouSmoke("N");
                      }}
                    >
                      No
                    </Button>
                    <Button
                      style={{ textTransform: "capitalize" }}
                      className={doYouSmoke == "Y" ? "ncbSelect" : "ncb"}
                      onClick={() => {
                        setDoYouSmoke("Y");
                      }}
                    >
                      Yes
                    </Button>
                  </div>
                </Grid>
                <Grid xs={6} sx={{ textAlign: "center" }}>
                  <p className="popup-subheading">Gender</p>
                  <div className="main-border-ncb">
                    <Button
                      style={{ textTransform: "capitalize" }}
                      className={termGender == "M" ? "ncbSelect" : "ncb"}
                      onClick={() => {
                        setTermGender("M");
                      }}
                    >
                      Male
                    </Button>
                    <Button
                      style={{ textTransform: "capitalize" }}
                      className={termGender == "F" ? "ncbSelect" : "ncb"}
                      onClick={() => {
                        setTermGender("F");
                      }}
                    >
                      Female
                    </Button>
                  </div>
                </Grid>
              </Grid>

              <Grid
                container
                spacing={2}
                justifyContent="center"
                className="mb-4"
              >
                <Grid xs={4} className="inputField">
                  <SelectDropdown
                    class_name="inputField"
                    title="Annual  Income"
                    value={annualIncome}
                    attrName={setAnnualIncome}
                    value_update={updateMasterState}
                    dropdown_data={annual_income_data}
                    warn_status={false}
                  />
                  {""}
                </Grid>
                <Grid xs={4} className="inputField">
                  <SelectDropdown
                    class_name="inputField"
                    title="Age"
                    value={termAge}
                    attrName={setTermAge}
                    value_update={updateMasterState}
                    dropdown_data={termAge_data}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={4}>
                  <RKTextField
                    class_name="inputField"
                    title="Pincode"
                    value={pincode}
                    value_update={updateMasterState}
                    attrName={setPincode}
                    warn_status={warnPincode}
                  />
                </Grid>
              </Grid>
            </div>
          )}
          {pageStatus == 2 ? (
            <Grid container spacing={2}>
              <Grid xs={12} className="tick_animation">
                <svg
                  className="checkmark"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 52 52"
                >
                  <circle
                    className="checkmark__circle"
                    cx="26"
                    cy="26"
                    r="25"
                    fill="none"
                  />
                  <path
                    className="checkmark__check"
                    fill="none"
                    d="M14.1 27.2l7.1 7.2 16.7-16.8"
                  />
                </svg>
                <p className="quote_success">
                  New Term Insurance Policy has been added successfully!
                </p>
              </Grid>
            </Grid>
          ) : null}
          <Grid container spacing={2}>
            {pageStatus == 2 ? null : (
              <Grid
                xs={12}
                style={{ textAlign: "center", position: "relative" }}
                className="ctaBtn"
              >
                <Button
                  variant="contained"
                  className="submitBtn fixedbtn"
                  onClick={() => {
                    changePageStatus(true);
                  }}
                >
                  {pageStatus == 1 ? "Submit" : "Continue"}
                </Button>
              </Grid>
            )}
          </Grid>
        </div>
      </SlidingPanel>
    </>
  );
};

export default TermForm;
